import { useState, useEffect, useContext } from "react";
import Table from "rc-table";
import "../../styling/Bookings.css";
import { PiCaretUpDownFill } from "react-icons/pi";
import moment from "moment";
import { EventDataContext } from "../EventDataContext";

const ClientEventsTableBusiness = ({ event, onEventClick, setInitialBusinessEventTab }) => {
  // State for tracking current sort column and order
  const [sortOrder, setSortOrder] = useState({});
 
  // State for sorted data (separate from props to avoid direct mutation)
  const [sortedData, setSortedData] = useState(event);

  // Context to share event details
  const { EventData, setEventData } = useContext(EventDataContext);


  // Sync sortedData with incoming props
  useEffect(() => {
    setSortedData(event);
  }, [event]);

  // Sort handler
  const handleSort = (column) => {
    const order = sortOrder[column] === "asc" ? "desc" : "asc";

    setSortOrder({ [column]: order });

    const sorted = [...sortedData].sort((a, b) => {
      let valA = a[column];
      let valB = b[column];

      // Convert strings to lowercase for comparison
      if (typeof valA === "string") valA = valA.toLowerCase();
      if (typeof valB === "string") valB = valB.toLowerCase();

      if (valA < valB) return order === "asc" ? -1 : 1;
      if (valA > valB) return order === "asc" ? 1 : -1;
      return 0;
    });

    setSortedData(sorted); // Update table with sorted data
  };

  // Columns definition
  const columns = [
    {
      title: (
        <div
          className={`custom-header ${
            sortOrder.column === "eventName" ? "sorted" : ""
          }`}
          onClick={() => handleSort("eventName")}
        >
          <PiCaretUpDownFill className="table-header-icon" />
          Event Name
        </div>
      ),
      dataIndex: "eventName",
      key: "eventName",
      width: 100,
      align: "left",
      render: (text, record) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onEventClick(record._id); 
            setEventData(record);
            setInitialBusinessEventTab(0)
          }}
          style={{ color: "#1C1154", textDecoration: "none" }}
        >
          <h4 style={{ margin: "0px" }}>{text}</h4>
        </a>
      ),
    },
    {
      title: (
        <div
          className={`custom-header ${
            sortOrder.column === "status" ? "sorted" : ""
          }`}
          onClick={() => handleSort("status")}
        >
          <PiCaretUpDownFill className="table-header-icon" />
          Event Status
        </div>
      ),
      dataIndex: "status",
      key: "status",
      width: 100,
      align: "left",
      render: (text) => text.toUpperCase(),
    },
    {
      title: (
        <div
          className={`custom-header ${
            sortOrder.column === "expPaymentAmount" ? "sorted" : ""
          }`}
          onClick={() => handleSort("expPaymentAmount")}
        >
          <PiCaretUpDownFill className="table-header-icon" />
          Event Total
        </div>
      ),
      dataIndex: "expPaymentAmount",
      key: "expPaymentAmount",
      width: 100,
      align: "left",
      render: (amount) => `$ ${amount}`,
    },
    {
      title: (
        <div
          className={`custom-header ${
            sortOrder.column === "eventDate" ? "sorted" : ""
          }`}
          onClick={() => handleSort("eventDate")}
        >
          <PiCaretUpDownFill className="table-header-icon" />
          Event Date
        </div>
      ),
      dataIndex: "eventDate",
      key: "eventDate",
      width: 100,
      align: "left",
      render: (date) => (
        <span>{moment(new Date(date)).format("MMM DD, YYYY")}</span>
      ),
    },
  ];

  const rowClassName = () => "custom-table-row";

  const customRowClassName = () => "table-row-with-border";

  return (
    <div className="events-table" style={{marginLeft:'-6px', width:'97%'}}>
      <Table
        columns={columns}
        data={sortedData}
        scroll={{ x: "100%" }}
        rowClassName={(record, index) =>
          `${rowClassName(record, index)} ${customRowClassName(record, index)}`
        }
        components={{
          header: {
            cell: (props) => (
              <th
                {...props}
                style={{
                  borderBottom: "1px solid #D9D9D9",
                  height: "50px",
                  textAlign: "left",
                }}
              >
                {props.children}
              </th>
            ),
          },
        }}
      />
    </div>
  );
};

export default ClientEventsTableBusiness;